import {createBrowserRouter, Navigate} from "react-router-dom"

import {LoginPage} from "../../pages/login/LoginPage"
import {DashboardPage} from "../../pages/dashboard/DashboardPage"
import {AnalyticsLayout} from "../../pages/analytics/AnalyticsLayout"
import {OverviewPage} from "../../pages/analytics/OverviewPage"
import {UsersAnalyticsPage} from "../../pages/analytics/UsersAnalyticsPage"
import {CoursesListPage} from "../../pages/analytics/CoursesListPage"
import {CourseDetailPage as AnalyticsCourseDetailPage} from "../../pages/analytics/CourseDetailPage"
import {CourseDropoutPage} from "../../pages/analytics/CourseDropoutPage"
import {MentorsAnalyticsPage} from "../../pages/analytics/MentorsAnalyticsPage"
import {MentorDetailPage} from "../../pages/analytics/MentorDetailPage"
import {VacanciesAnalyticsPage} from "../../pages/analytics/VacanciesAnalyticsPage"
import {VacancyDetailPage} from "../../pages/analytics/VacancyDetailPage"
import {ChinaAnalyticsPage} from "../../pages/analytics/ChinaAnalyticsPage"
import {ChinaEnterpriseDetailPage} from "../../pages/analytics/ChinaEnterpriseDetailPage"
import {ProfilePage} from "../../pages/profiles/ProfilePage"
import {MentorCoursesPage} from "../../pages/mentor/MentorCoursesPage"
import {MentorAnalyticsLayout} from "../../pages/mentor/MentorAnalyticsLayout"
import {MentorAnalyticsCoursesPage} from "../../pages/mentor/MentorAnalyticsCoursesPage"
import {MentorAnalyticsCourseDetailPage} from "../../pages/mentor/MentorAnalyticsCourseDetailPage"
import {MentorAnalyticsCourseDropoutPage} from "../../pages/mentor/MentorAnalyticsCourseDropoutPage"
import {MentorAnalyticsProfileViewsPage} from "../../pages/mentor/MentorAnalyticsProfileViewsPage"

import {CoursePage} from "../../pages/courses/CoursePage"
import {CreateCoursePage} from "../../pages/courses/CreateCoursePage"
import {CourseDetailPage} from "../../pages/courses/CourseDetailPage"

import {ModuleDetailPage} from "../../pages/modules/ModuleDetailPage"
import {LessonDetailPage} from "../../pages/lessons/LessonDetailPage"
import {CreateLessonPage} from "../../pages/lessons/CreateLessonPage"

import {UsersPage} from "../../pages/users/UsersPage"
import {CategoryPage} from "../../pages/categories/CategoryPage"
import {PurchaseRequestsPage} from "../../pages/purchase-request/PurchaseRequestsPage"
import {ChinaEnterprisesPage} from "../../pages/china-enterprises/ChinaEnterprisesPage"
import {ChinaMarketsPage} from "../../pages/china-markets/ChinaMarketsPage"
import {OrdersPage} from "../../pages/payments/OrdersPage"
import {PaymentResultPage} from "../../pages/payments/PaymentResultPage"
import {PaymentsPage} from "../../pages/payments/PaymentsPage"
import {SubscriptionsPage} from "../../pages/payments/SubscriptionsPage"
import {SubscriptionPlansPage} from "../../pages/payments/SubscriptionPlansPage"
import {IapTiersPage} from "../../pages/payments/IapTiersPage"
import {LimitsPage} from "../../pages/payments/LimitsPage"

import {ProtectedRoute} from "../../shared/lib/ProtectedRoute"
import {AdminOnly} from "../../shared/lib/AdminOnly"
import {NotFoundPage} from "../../pages/not-found/NotFoundPage"

import {ChatsPage} from "../../pages/chat/ChatsPage";
import {ChatHistoryPage} from "../../pages/chat/ChatHistoryPage";
import {CourseChatPage} from "../../pages/course-chat/CourseChatPage";
import {CourseGroupChatHistoryPage} from "../../pages/chat/CourseGroupChatHistoryPage";
import {CoursePrivateChatHistoryPage} from "../../pages/chat/CoursePrivateChatHistoryPage";
import {LandingPage} from "../../pages/landing/LandingPage";
import {ReferralLandingPage} from "../../pages/referral/ReferralLandingPage";
import {PrivacyPolicyPage} from "../../pages/privacy-policy/PrivacyPolicyPage";
import {TermsOfUsePage} from "../../pages/terms-of-use/TermsOfUsePage";
import {SupportPage} from "../../pages/support/SupportPage";
import {PublicOfferPage} from "../../pages/public-offer/PublicOfferPage";
import {RefundPolicyPage} from "../../pages/refund-policy/RefundPolicyPage";
import {CardPaymentPage} from "../../pages/card-payment/CardPaymentPage";
import {ReportsHubPage} from "../../pages/reports/ReportsHubPage";
import {ReportsListPage} from "../../pages/reports/ReportsListPage";
import {AdminReviewsHubPage} from "../../pages/reviews/AdminReviewsHubPage";
import {AdminReviewsPage} from "../../pages/reviews/AdminReviewsPage";
import {VacanciesPage} from "../../pages/vacancies/VacanciesPage";
import {ReferralsLayout} from "../../pages/referrals/ReferralsLayout";
import {OverviewPage as ReferralsOverviewPage} from "../../pages/referrals/OverviewPage";
import {TopReferrersPage} from "../../pages/referrals/TopReferrersPage";
import {ReferralUsersPage} from "../../pages/referrals/ReferralUsersPage";
import {ReferralUserDetailPage} from "../../pages/referrals/ReferralUserDetailPage";
import {NotificationsLayout} from "../../pages/notifications/NotificationsLayout";
import {BroadcastPage} from "../../pages/notifications/BroadcastPage";
import {NotificationHistoryPage} from "../../pages/notifications/NotificationHistoryPage";
import {NotificationDetailPage} from "../../pages/notifications/NotificationDetailPage";

export const router = createBrowserRouter([
    {path: "/", element: <LandingPage/>},
    {path: "/r/:code", element: <ReferralLandingPage/>},

    {
        path: "/dashboard",
        element: (
            <ProtectedRoute>
                <AdminOnly>
                    <DashboardPage/>
                </AdminOnly>
            </ProtectedRoute>
        ),
    },

    {path: "/privacy-policy", element: <PrivacyPolicyPage/>},
    {path: "/terms-of-use", element: <TermsOfUsePage/>},
    {path: "/support", element: <SupportPage/>},
    {path: "/public-offer", element: <PublicOfferPage/>},
    {path: "/refund-policy", element: <RefundPolicyPage/>},
    {path: "/card-payment", element: <CardPaymentPage/>},
    {path: "/payment/result", element: <PaymentResultPage/>},
    {path: "/login", element: <LoginPage/>},

    {
        path: "/chats",
        element: (
            <ProtectedRoute>
                <ChatsPage/>
            </ProtectedRoute>
        ),
    },
    {
        path: "/courses/:courseId/chat",
        element: (
            <ProtectedRoute>
                <CourseChatPage/>
            </ProtectedRoute>
        ),
    },
    {
        path: "/courses/:courseId/group-chat",
        element: (
            <ProtectedRoute>
                <CourseGroupChatHistoryPage/>
            </ProtectedRoute>
        ),
    },

    {
        path: "/chats/:chatId/history",
        element: (
            <ProtectedRoute>
                <ChatHistoryPage/>
            </ProtectedRoute>
        ),
    },

    {
        path: "/courses/:courseId/chat/private/:studentId",
        element: (
            <ProtectedRoute>
                <CoursePrivateChatHistoryPage/>
            </ProtectedRoute>
        ),
    },

    {
        path: "/profile",
        element: (
            <ProtectedRoute>
                <ProfilePage/>
            </ProtectedRoute>
        ),
    },

    {
        path: "/mentor/courses",
        element: (
            <ProtectedRoute>
                <MentorCoursesPage/>
            </ProtectedRoute>
        ),
    },

    {
        path: "/mentor/analytics",
        element: (
            <ProtectedRoute>
                <MentorAnalyticsLayout />
            </ProtectedRoute>
        ),
        children: [
            { index: true, element: <Navigate to="courses" replace /> },
            { path: "courses",                      element: <MentorAnalyticsCoursesPage /> },
            { path: "courses/:courseId",             element: <MentorAnalyticsCourseDetailPage /> },
            { path: "courses/:courseId/dropout",     element: <MentorAnalyticsCourseDropoutPage /> },
            { path: "profile-views",                 element: <MentorAnalyticsProfileViewsPage /> },
        ],
    },

    {
        path: "/courses",
        element: (
            <ProtectedRoute>
                <AdminOnly>
                    <CoursePage/>
                </AdminOnly>
            </ProtectedRoute>
        ),
    },

    {
        path: "/courses/:id",
        element: (
            <ProtectedRoute>
                    <CourseDetailPage/>
            </ProtectedRoute>
        ),
    },

    {
        path: "/courses/:courseId/modules/:moduleId",
        element: (
            <ProtectedRoute>
                    <ModuleDetailPage/>
            </ProtectedRoute>
        ),
    },

    {
        path: "/modules/:moduleId/lessons/:lessonId",
        element: (
            <ProtectedRoute>
                    <LessonDetailPage/>
            </ProtectedRoute>
        ),
    },

    {
        path: "/modules/:moduleId/lessons/create",
        element: (
            <ProtectedRoute>
                    <CreateLessonPage/>
            </ProtectedRoute>
        ),
    },

    {
        path: "/courses/create",
        element: (
            <ProtectedRoute>
                <AdminOnly>
                    <CreateCoursePage/>
                </AdminOnly>
            </ProtectedRoute>
        ),
    },

    {
        path: "/categories",
        element: (
            <ProtectedRoute>
                <AdminOnly>
                    <CategoryPage/>
                </AdminOnly>
            </ProtectedRoute>
        ),
    },

    {
        path: "/users",
        element: (
            <ProtectedRoute>
                <AdminOnly>
                    <UsersPage/>
                </AdminOnly>
            </ProtectedRoute>
        ),
    },

    {
        path: "/purchase-requests",
        element: (
            <ProtectedRoute>
                <AdminOnly>
                    <PurchaseRequestsPage/>
                </AdminOnly>
            </ProtectedRoute>
        ),
    },

    {
        path: "/admin/orders",
        element: (
            <ProtectedRoute>
                <AdminOnly>
                    <OrdersPage/>
                </AdminOnly>
            </ProtectedRoute>
        ),
    },

    {
        path: "/admin/payments",
        element: (
            <ProtectedRoute>
                <AdminOnly>
                    <PaymentsPage/>
                </AdminOnly>
            </ProtectedRoute>
        ),
    },

    {
        path: "/admin/subscriptions",
        element: (
            <ProtectedRoute>
                <AdminOnly>
                    <SubscriptionsPage/>
                </AdminOnly>
            </ProtectedRoute>
        ),
    },

    {
        path: "/admin/subscription-plans",
        element: (
            <ProtectedRoute>
                <AdminOnly>
                    <SubscriptionPlansPage/>
                </AdminOnly>
            </ProtectedRoute>
        ),
    },

    {
        path: "/admin/iap-tiers",
        element: (
            <ProtectedRoute>
                <AdminOnly>
                    <IapTiersPage/>
                </AdminOnly>
            </ProtectedRoute>
        ),
    },

    {
        path: "/admin/limits",
        element: (
            <ProtectedRoute>
                <AdminOnly>
                    <LimitsPage/>
                </AdminOnly>
            </ProtectedRoute>
        ),
    },

    {
        path: "/china-enterprises",
        element: (
            <ProtectedRoute>
                <AdminOnly>
                    <ChinaEnterprisesPage/>
                </AdminOnly>
            </ProtectedRoute>
        ),
    },

    {
        path: "/china-markets",
        element: (
            <ProtectedRoute>
                <AdminOnly>
                    <ChinaMarketsPage/>
                </AdminOnly>
            </ProtectedRoute>
        ),
    },

    {
        path: "/vacancies",
        element: (
            <ProtectedRoute>
                <AdminOnly>
                    <VacanciesPage/>
                </AdminOnly>
            </ProtectedRoute>
        ),
    },

    {
        path: "/reports",
        element: (
            <ProtectedRoute>
                <AdminOnly>
                    <ReportsHubPage/>
                </AdminOnly>
            </ProtectedRoute>
        ),
    },

    {
        path: "/reports/:type",
        element: (
            <ProtectedRoute>
                <AdminOnly>
                    <ReportsListPage/>
                </AdminOnly>
            </ProtectedRoute>
        ),
    },

    {
        path: "/admin/reviews",
        element: (
            <ProtectedRoute>
                <AdminOnly>
                    <AdminReviewsHubPage/>
                </AdminOnly>
            </ProtectedRoute>
        ),
    },

    {
        path: "/admin/reviews/:type",
        element: (
            <ProtectedRoute>
                <AdminOnly>
                    <AdminReviewsPage/>
                </AdminOnly>
            </ProtectedRoute>
        ),
    },

    {
        path: "/admin/analytics",
        element: (
            <ProtectedRoute>
                <AdminOnly>
                    <AnalyticsLayout />
                </AdminOnly>
            </ProtectedRoute>
        ),
        children: [
            { index: true, element: <Navigate to="overview" replace /> },
            { path: "overview",               element: <OverviewPage /> },
            { path: "users",                  element: <UsersAnalyticsPage /> },
            { path: "courses",                element: <CoursesListPage /> },
            { path: "courses/:courseId",      element: <AnalyticsCourseDetailPage /> },
            { path: "courses/:courseId/dropout", element: <CourseDropoutPage /> },
            { path: "mentors",                element: <MentorsAnalyticsPage /> },
            { path: "mentors/:mentorId",      element: <MentorDetailPage /> },
            { path: "vacancies",              element: <VacanciesAnalyticsPage /> },
            { path: "vacancies/:vacancyId",   element: <VacancyDetailPage /> },
            { path: "china",                  element: <ChinaAnalyticsPage /> },
            { path: "china/:enterpriseId",    element: <ChinaEnterpriseDetailPage /> },
        ],
    },

    {
        path: "/admin/referrals",
        element: (
            <ProtectedRoute>
                <AdminOnly>
                    <ReferralsLayout />
                </AdminOnly>
            </ProtectedRoute>
        ),
        children: [
            { index: true, element: <Navigate to="overview" replace /> },
            { path: "overview",       element: <ReferralsOverviewPage /> },
            { path: "top",            element: <TopReferrersPage /> },
            { path: "users",          element: <ReferralUsersPage /> },
            { path: "users/:userId",  element: <ReferralUserDetailPage /> },
        ],
    },

    {
        path: "/admin/notifications",
        element: (
            <ProtectedRoute>
                <AdminOnly>
                    <NotificationsLayout />
                </AdminOnly>
            </ProtectedRoute>
        ),
        children: [
            { index: true, element: <Navigate to="broadcast" replace /> },
            { path: "broadcast",     element: <BroadcastPage /> },
            { path: "history",       element: <NotificationHistoryPage /> },
            { path: "history/:id",   element: <NotificationDetailPage /> },
        ],
    },

    {path: "*", element: <NotFoundPage/>},
])


